import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { FaArrowLeft, FaCalendarAlt, FaClock, FaMapMarkerAlt, FaUsers } from 'react-icons/fa';
import { Event } from '../../firebase/firestore';

interface EventDetailPageProps {
  event: Event;
  onBack: () => void;
}

const Container = styled.div`
  padding: ${theme.spacing.lg};
`;

const BackButton = styled.button`
  background: ${theme.colors.white};
  color: ${theme.colors.secondary};
  border: 2px solid ${theme.colors.lightGray};
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.lg};
`;

const Card = styled.div`
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.md};
  padding: ${theme.spacing.xl};
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${theme.colors.secondary};
  margin-bottom: ${theme.spacing.md};
`;

const Meta = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.lg};
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  color: ${theme.colors.mediumGray};
`;

const EventDetailPage: React.FC<EventDetailPageProps> = ({ event, onBack }) => {
  return (
    <Container>
      <BackButton onClick={onBack}>
        <FaArrowLeft /> Back to events
      </BackButton>

      <Card>
        <Title>{event.title}</Title>
        <Meta>
          <MetaItem><FaCalendarAlt /> {event.date.toLocaleDateString()}</MetaItem>
          <MetaItem><FaClock /> {event.time}</MetaItem>
          <MetaItem><FaMapMarkerAlt /> {event.location}</MetaItem>
          <MetaItem><FaUsers /> {event.currentAttendees.length}/{event.maxAttendees} attendees</MetaItem>
        </Meta>
        <p style={{ color: theme.colors.mediumGray, lineHeight: 1.6 }}>{event.description}</p>
      </Card>
    </Container>
  );
};

export default EventDetailPage;



